import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import KeyValuePair from "../../interfaces/keyValuePair";

interface MultiSelectProps {
	pool: KeyValuePair<number, string>[];
	selected: KeyValuePair<number, string>[];
	className: string;
	defaultText?: string;
	onSelectedChange: (selected: KeyValuePair<number, string>[]) => void;
}

export default function MultiSelect(props: MultiSelectProps) {
	const { pool, selected, className, defaultText } = props;

	function removeItem(
		event: React.MouseEvent<HTMLElement>,
		target: KeyValuePair<number, string>
	) {
		event.preventDefault();
		if (!selected) return;
		var newSelected = selected.filter((item) => item != target);
		props.onSelectedChange(newSelected);
	}

	return (
		<div className={className}>
			<Listbox multiple value={selected} onChange={props.onSelectedChange}>
				<div className="relative">
					<ListboxButton className="relative w-full min-h-[56px] cursor-default rounded-lg bg-white py-1 pl-3 pr-10 text-left border-0 text-gray-900 text-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600">
						<span className="block">
							{(!selected || selected.length === 0) && defaultText && (
								<span className="text-gray-500">{defaultText}</span>
							)}
							{selected &&
								selected.length > 0 &&
								selected.map((kvp, index) => (
									<span
										key={index}
										className="border border-gray-300 rounded-md p-2 mr-2 my-1 inline-block">
										{kvp.value}
										<span
											className="pl-2"
											onClick={(event) => removeItem(event, kvp)}>
											⨯
										</span>
									</span>
								))}
						</span>
						<span className="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2">
							<ChevronUpDownIcon
								className="h-5 w-5 text-gray-400"
								aria-hidden="true"
							/>
						</span>
					</ListboxButton>
					{selected.length < pool.length && (
						<ListboxOptions
							className={
								"absolute mt-1 py-1 max-h-48 w-full overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden z-10 sm:text-sm " +
								"transition ease-in duration-10000 data-[closed]-opacity-0 data-[open]-opacity-100"
							}>
							{pool.map((kvp, index) => (
								<ListboxOption
									key={index}
									className={`relative cursor-default select-none py-2 pl-4 pr-4 text-gray-900`}
									hidden={!!selected.find((x) => x.key === kvp.key)}
									value={kvp}>
									<span className="block truncate font-normal">{kvp.value}</span>
								</ListboxOption>
							))}
						</ListboxOptions>
					)}
				</div>
			</Listbox>

			<button
				className="btn btn-naked btn-small mt-1"
				onClick={() => props.onSelectedChange(pool)}>
				Select All
			</button>
			<button
				className="btn btn-naked btn-small mt-1"
				onClick={() => props.onSelectedChange([])}>
				Clear
			</button>
		</div>
	);
}
